<template>
  <div class="outer">
    <div v-for="(item,index) in classify" :key="index" class="title">
      {{item.title}}
      <div
        class="content"
        v-for="(item,index) in item.content"
        :key="index"
        @click="reportHandler(item)"
      >
        {{item}}
        <img src="../assets/image/arrow.png" class="arrow" alt />
      </div>
    </div>
  </div>
</template>
<script>
import { SAVEPARAMS } from "../vuex/mutations-type";
export default {
  data() {
    return {
      classify: [
        {
          title: "内容举报",
          content: [
            "色情低俗",
            "政治敏感",
            "违法犯罪",
            "垃圾广告、售卖假货等",
            "造谣传谣、涉嫌欺诈",
            "侮辱谩骂"
          ]
        },
        {
          title: "未成年",
          content: ["未成年不当行为", "内容不适合未成年观看"]
        },
        {
          title: "其他",
          content: ["引人不适", "疑似自我伤害", "诱导分享、关注", "其他"]
        }
      ],
      form: {
        type: "",
        exploreShopNo: "",
        reportExploreShopNo: "",
        videoId: "",
        reportClass: ""
      }
    };
  },
  mounted() {
    const {
      exploreShopNo,
      reportExploreShopNo,
      videoId,
      type
    } = this.$route.query;
    this.form = {
      type:+type,
      exploreShopNo,
      reportExploreShopNo,
      videoId,
    };
  },
  methods: {
    reportHandler(item) {
      this.form.reportClass = item;
      const { form } = this;
      this.$store.commit(SAVEPARAMS, form);
      this.$router.push("/tip-off-detail");
    }
  }
};
</script>
<style lang="scss" scoped>
.outer {
  padding: 40px 30px 0 30px;
  .title {
    font-size: 24px;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 30px;
      font-weight: 500;
      color: rgba(1, 1, 1, 1);
      margin-bottom: 58px;
      &:first-child {
        margin-top: 46px;
      }
      .arrow {
        width: 30px;
        height: 32px;
      }
    }
  }
  .other {
    font-size: 30px;
    font-weight: 500;
    color: rgba(1, 1, 1, 1);
  }
}
</style>